import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
// run the SJI application
import { SJIModule } from './sjiapp.module';
import { SJIAppComponent } from './sjiapp.component';

@NgModule({
  declarations: [
    SJIAppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    SJIModule,
  ],
  providers: [],
  bootstrap: [SJIAppComponent]
})
/**
 * The AppModule which occupies the root of the folder is purposely kept as bare as possible.
 * It’s role is simply to bootstrap the Angular application, and provide the root-level router-outlet.
 * This approach also leaves open the possibility of running multiple,
 * independent Angular applications through the same base URL.
 * It also introduces the idea of building a router-driven Angular application.
 */
export class AppModule { }
